<template>
  <div style="position: relative">
    <a-table v-bind="$attrs" :key="tableKey" tableLayout="fixed" :pagination="newPagination" :columns="newColumns"
      :rowKey="rowKey" :scroll="scrollCalc" :defaultExpandAllRows="isExpanded_hidden ? !isExpanded_hidden : isExpanded"
      :rowClassName="rowClassFunc"
      :row-selection="isRowSelection ? {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: preserveSelectedRowKeys,
        onSelect: onUserSel,
        onSelectAll: onUserSelAll,
      } : null" @change="pageChange" @expand="expandedOneRows" :expandedRowKeys="expandedRowKeys" bordered
      :dataSource="realDataSource.length? realDataSource : dataSource" :transformCellText="transformCellText" class="wmstable" ref="wmstable">
      <div class="table__div--title" slot="title" v-if="hasHeader">
        <slot name="title"></slot>
        <CustomizeChoose v-model="showColumns" :columnsTags="columns" :filterSoltHeader="filterSoltHeader"/>
      </div>
      <template v-for="item in slots" :slot="item" slot-scope="text, record, index">
        <slot :name="item" :text="text" :record="record" :index="index"></slot>
      </template>
      <div :slot="isExpanded_hidden ? 'expandedRowRender' : isExpanded ? 'expandedRowRender' : ''" slot-scope="record"
        name="expandedRender"
        :style="`position: sticky;left:0px;width:${son_width}px;z-index:9;padding-right:20px;box-sizing:border-box`">
        <slot :record="record" name="expandedRender"></slot>
      </div>
    </a-table>

    <div :class="hasHeader ? 'expendBtn expendBtn_low' : 'expendBtn'" @click="openAllExpend" v-if="
      dataSource.length > 0 && (isExpanded_hidden || isExpanded) && openAll
    ">
      <div class="expendBtnImg" :style="
        isOpenAllExpaneded
          ? 'transform: rotate(0deg);'
          : 'transform: rotate(180deg)'
      ">
        <svg viewBox="0 0 1024 1024" width="128" height="128" fill="currentColor">
          <path d="M806.4 319.2L512 613.6 221.6 323.2 176 368l290.4 290.4L512 704l45.6-45.6 294.4-294.4z" p-id="4807">
          </path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 待优化：
 *      分页逻辑（两层封装导致，参数过于复杂）
 *      row-selection 刷新重置逻辑，需要冲最外层手动触发，目标是在当前层自动处理。
 *
 * **/
import CustomizeChoose from "./CustomizeChoose";
import { Table } from "ant-design-vue";
import "ant-design-vue/lib/table/style/css";

export default {
  name: "WmsTable",
  components: {
    CustomizeChoose,
    [Table.name]: Table,
  },
  props: {
    rowKey: {
      type: String,
      default: () => { return 'id' },
    },
    isPagination: {
      // 是否有 pagination
      type: Boolean | Object,
      default: () => true,
    },
    hasHeader: {
      // 是否有 header
      type: Boolean,
      default: () => true,
    },
    isRowSelection: {
      //  是否有 RowSelection
      type: Boolean,
      default: () => false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isExpanded: {
      //  是否默认展开 ---------- 可优化
      type: Boolean,
      default: () => false,
    },
    //true 就是带展开且默认收起 false就去看isExpanded 兼容以前的写法
    isExpanded_hidden: {
      type: Boolean,
      default: () => false,
    },
    clean: {
      // 用于数据刷新时清除， 已选择的 selectedRowKeys 和 selectedRows --------- 想优化
      type: Boolean | String,
      default: () => false,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    listener: {
      type: Boolean,
      default: () => false,
    },
    scroll: {
      type: Boolean,
      default: () => true,
    },
    scrollY: {
      type: Number,
    },
    rowClassList: {
      type: Array | Boolean,
      default: () => false,
    },
    // 跨页面勾选记忆功能
    preserveSelectedRowKeys: {
      type: Boolean,
      default: () => false,
    },
    keepExpended: {
      type: Boolean,
      default: () => false,
    },
    parentTable: {
      type: Object,
      required: false,
    },
    sonRecordId: {
      type: String | Number,
      required: false,
    },
    son_level: {
      type: Number,
      default: () => 0,
    },
    openAll: {
      type: Boolean,
      default: () => false,
    },
    rowClassFunc:{
      type:Function,
      default:()=>{}
    },
    filterSoltHeader: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      tableKey: Math.random().toFixed(8),
      showColumns: [],
      selectedRowKeys: [],
      selectedRows: [],
      selectedRowKeysCache: [],
      selectedRowsCache: [],
      expandedRowKeys: [],
      defaultExpandedRowKeys: [],
      targetLeft: 0,
      son_width: "1500",
      lang: 1,
      realDataSource: []
    };
  },
  watch: {
    dataSource: {
      handler: function (newVal) {
        if (newVal) {
          this.realDataSource = [...newVal]
          let keepExpendList = [];
          if (this.keepExpended) {
            this.expandedRowKeys.forEach((item) => {
              let obj = {};
              obj[this.rowKey] = item;
              keepExpendList.push(obj);
            });
          }
          this.expandedRowKeys = [];
          this.selectedRows = [];
          this.selectedRowKeys = [];
          if (this.preserveSelectedRowKeys) {
            this.selectedRows = this.selectedRowsCache;
            this.selectedRowKeys = this.selectedRowKeysCache;
            this.selectedRowsCache = [];
            this.selectedRowKeysCache = [];
          }
          this.$emit("selectChange", this.selectedRows);
          if (newVal.length > 0) {
            setTimeout(() => {
              // let el2 = document.querySelectorAll(`.ant-table-wrapper`)
              // console.log(el2)
              // this.son_width = (el2[el2.length - 1].getBoundingClientRect().width - 90)
              //取消defaultExpandedRowKeys对默认展开行的控制，手动控制默认展开
              //不然不好控制对哪个ant-table-body进行监听 也不好计算展开行fixed的高度
              if (this.isExpanded) {
                newVal.forEach((item) => {
                  this.expandedOneRows(true, item);
                });
              } else {
                if (this.keepExpended) {
                  keepExpendList.forEach((item) => {
                    this.expandedOneRows(true, item);
                  });
                }
              }
            });
          }
        }
      },
    },
    rowClassList: {
      handler: function (newVal) {
        if (newVal) {
          for (let i in newVal) {
            setTimeout(() => {
              const elements = document.querySelector(
                `[data-row-key=${newVal[i]}]`
              );
              elements.style.backgroundColor = "#aed8ff";
            }, 300);
          }
        }
      },
    },
  },
  computed: {
    newPagination: function () {
      let _pagination = {};
      if (this.isPagination) {
        const { current = 1, pageSize = 10, total = 0 } = this.isPagination;
        _pagination = {
          current,
          pageSize,
          total,
          pageSizeOptions: [
            "10",
            "20",
            "30",
            "40",
            "50",
            "60",
            "70",
            "80",
            "90",
            "100",
          ],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条";
          },
          showQuickJumper: true,
          showSizeChanger: true,
        };
      } else {
        _pagination = false;
      }
      return _pagination;
    },
    slots: function () {
      const _slots = this.columns
        .filter((item) => !!item.scopedSlots)
        .map((item) => item.scopedSlots.customRender);
      return _slots;
    },
    newColumns: function () {
      const checkedKeys = this.showColumns
        .filter((item) => item.checked)
        .map((item) => item.key);
      let _columns = this.columns;
      if (this.hasHeader) {
        _columns = this.columns.filter((item) => {
          if (!this.filterSoltHeader && (item.title === "#" || !!item.scopedSlots)) {
            return true;
          } else {
            return checkedKeys.indexOf(item.key) !== -1;
          }
        });
      }
      return _columns;
    },
    scrollCalc: function () {
      let xLength = 0;
      this.newColumns.forEach((item) => {
        xLength += item.width ? item.width : 188;
      });
      const _scroll = { x: xLength + this.lang };
      if (this.scrollY) {
        _scroll.y = this.scrollY;
      }
      return this.scroll ? _scroll : {};
    },
    isOpenAllExpaneded: function () {
      return this.dataSource.some(
        (item) => !this.expandedRowKeys.some((row) => row == item[this.rowKey])
      );
    },
  },
  activated() {
    this.targetLeft = 0;
    this.lang = this.lang == 1 ? 2 : 1;
  },
  deactivated() {
    this.targetLeft = 0;
  },
  updated() {
    let width = this.$refs.wmstable.$el.getBoundingClientRect().width;
    this.son_width = width - 70;
    if (this.listener) {
      let el = document.querySelectorAll(".ant-table-body");
      if (el) {
        el[el.length - 1].addEventListener("scroll", this.scrollCall);
      }
    }
  },
  methods: {
    getComponent(componentName) {
      let that = this;
      let component = null;
      let parent = that.$parent;
      while (parent && !component) {
        if (parent.$options._componentTag === componentName) {
          component = parent;
        }
        parent = parent.$parent;
      }
      return component;
    },
    scrollCall(res) {
      this.targetLeft = res.target.scrollLeft;
    },
    pageChange: function (pagination) {
      // this.pagination = pagination
      const { current, pageSize } = pagination;
      if (this.preserveSelectedRowKeys) {
        this.selectedRowsCache = this.selectedRows;
        this.selectedRowKeysCache = this.selectedRowKeys;
        console.log(this.selectedRowsCache, this.selectedRowKeysCache);
      }
      this.$emit("pageChange", { current, pageSize });
      this.$emit("selectChange", this.selectedRows);
      document.querySelector(".content__div_anchor")?.scrollIntoView(true);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowsCache = selectedRows;
      this.selectedRowKeysCache = selectedRowKeys;
    },
    expandedOneRows(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record[this.rowKey]);
        //  解决Ant Design Vue table组件固定某列(fixed)和展开某行(expandedRowRender)不能同时使用
        this.calExpanded(record);
        this.$emit("expendOpen", record);
      } else {
        this.expandedRowKeys.splice(
          this.expandedRowKeys.indexOf(record[this.rowKey]),
          1
        );
        if (this.getComponent("WmsTable")) {
          this.getComponent("WmsTable").resetExpandHeight();
        }
      }
    },
    calExpanded(record) {
      let that = this;
      return new Promise(function (resolve, reject) {
        that.$nextTick(() => {
          setTimeout(() => {
            // //21 是 .ant-table-thead > tr > th, .ant-table-tbody 的padding10px + border 1px
            // const columnHeight = column[0].getBoundingClientRect().height - 21
            //expended
            // 计算需要展开高度， 采用append dom元素的方式撑开高度，直接修改高度，
            // 但是当前行触发moursemove事件 会触发dom style 重置
            // 33 是td 的 padding 值 加 border值
            // let el2 = document.querySelectorAll(`.ant-table-wrapper`)
            // that.son_width = (el2[that.son_level].getBoundingClientRect().width - 72)
            if (that.getComponent("WmsTable")) {
              that.getComponent("WmsTable").resetExpandHeight();
            }
            const element = document.querySelectorAll(
              `[data-row-key='${record[that.rowKey]}-extra-row']`
            );
            let height = 0;
            if (element[0]) {
              height = element[0].getBoundingClientRect().height - 21;
            }
            if (element[1]) {
              element[1].childNodes[0] &&
                (element[1].childNodes[0].innerHTML = `<div style="height: ${height}px;"></div>`);
              element[1].childNodes[1] &&
                (element[1].childNodes[1].innerHTML = `<div style="height: ${height}px;"></div>`);
            }
            if (element[2]) {
              element[2].innerHTML = `<div style="height: ${height + 21
                }px;border-right:1px solid #eee"></div>`;
            }
            resolve("1");
          }, 0);
        });
      });
    },
    resetExpandHeight() {
      let that = this;
      that.expandedRowKeys.forEach((item) => {
        let record = {};
        record[that.rowKey] = item;
        that.calExpanded(record);
      });
    },
    onUserSel(record, selected, selectedRows, nativeEvent) {
      let selectedRowKeysData = [...this.selectedRowKeys];
      let selectedRowsData = [...this.selectedRows];
      if (selected) {
        selectedRowKeysData.push(record[this.rowKey]);
        selectedRowsData.push(record);
      }
      if (!selected) {
        let rowindex = selectedRowKeysData.findIndex(
          (item) => item == record[this.rowKey]
        );
        selectedRowKeysData.splice(rowindex, 1);
        selectedRowsData.splice(rowindex, 1);
      }
      this.selectedRowKeys = selectedRowKeysData;
      this.selectedRows = selectedRowsData;
      this.$emit("selectChange", this.selectedRows);
    },
    onUserSelAll(selected, selectedRows, changeRows) {
      let selectedRowKeysData = [...this.selectedRowKeys];
      let selectedRowsData = [...this.selectedRows];
      if (selected) {
        let changeRowKeysData = changeRows.map((item) => {
          return item[this.rowKey];
        });
        selectedRowKeysData = selectedRowKeysData.concat(changeRowKeysData);
        selectedRowsData = selectedRowsData.concat(changeRows);
      } else {
        selectedRowsData.forEach((item) => {
          item.needSplice = false;
          changeRows.forEach((v) => {
            if (item[this.rowKey] == v[this.rowKey]) {
              item.needSplice = true;
              selectedRowKeysData.splice(
                selectedRowKeysData.findIndex((y) => y == v[this.rowKey]),
                1
              );
            }
          });
        });
        selectedRowsData = selectedRowsData.filter((item) => !item.needSplice);
      }
      this.selectedRowKeys = selectedRowKeysData;
      this.selectedRows = selectedRowsData;
      this.$emit("selectChange", this.selectedRows);
      this.$emit("selectChangeAll", this.selectedRows);
    },
    resetSel(rows = []) {
      this.selectedRows = rows;
      this.selectedRowKeys = rows.map(v=>v[this.rowKey]);
      console.log('resetSel')
      console.log(this.selectedRows,this.selectedRowKeys)
      this.$emit("selectChange", this.selectedRows);
    },
    openAllExpend() {
      let that = this;
      const loading = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (that.isOpenAllExpaneded) {
        let changeRows = [...that.dataSource].filter(
          (item) => !that.expandedRowKeys.some((row) => row[this.rowKey] == item[this.rowKey])
        );
        that.expandedRowKeys = [
          ...that.expandedRowKeys,
          ...changeRows.map((item) => item[this.rowKey]),
        ];
        function go(index) {
          that.calExpanded(changeRows[index]).then((res) => {
            if (index < changeRows.length - 1) {
              go(index + 1);
            } else {
              loading.close();
            }
          });
        }
        go(0);
      } else {
        that.expandedRowKeys = that.expandedRowKeys.filter(
          (row) => !that.dataSource.some((item) => item[this.rowKey] == row)
        );
        loading.close();
        if (that.parentTable && that.sonRecordId) {
          that.parentTable.calExpanded({ id: that.sonRecordId });
        }
      }
    },
    resetExpended() {
      this.expandedRowKeys = []
      this.keepExpendList = []
    },
    transformCellText({ text, column, record, index }) {
      return ( text || text === 0 ) ? text : record ? '-' : ''
    },
    changeDataSourceData(index, name, data) {
      this.realDataSource[index][name] = data
      this.calExpanded(this.realDataSource[index])
      this.$forceUpdate()
    }
  },
};
</script>

<style scoped>
.wmstable {
  position: relative;
}

.expendBtn {
  position: absolute;
  top: 2px;
  left: 0px;
  z-index: 99;
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2c3e50;
  transition: all 0.3s;
}

.expendBtn :hover {
  color: #1890ff;
}

.expendBtn svg {
  width: 20px;
  height: 20px;
}

.expendBtnImg {
  height: 20px;
  width: 20px;
}

path {
  fill: unset;
}

.expendBtn_low {
  top: 56px;
}

.table__div--title {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.expandedDiv {
  padding-left: 310px;
}
</style>

<style>
.ant-table-fixed-left,
.ant-table-fixed-right {
  box-shadow: none !important;
}

.ant-table-fixed {
  background: rgba(0, 0, 0, 0) !important;
}

.ant-table-fixed .ant-table-row td {
  background: #fff;
}

.ant-table-expanded-row td {
  border-right: none !important;
  border-left: none !important;
}

/* .ant-table-fixed-left .ant-table-fixed .ant-table-row {
  box-shadow: 6px 0 6px -4px rgb(0 0 0 / 15%) !important;
} */

.ant-table-expanded-row {
  left: 0;
  background: rgba(0, 0, 0, 0) !important;
}

.ant-table-expanded-row td:first-child {
  /* background: #fbfbfb !important; */
  border-right: 1px solid #e8e8e8 !important;
}

.tr.ant-table-row.ant-table-row-level-0.active {
  background-color: aqua;
}

.ant-table-fixed-right .ant-table-row td {
  border-left: 1px solid #eee !important;
}

.ant-table-fixed-right .ant-table-thead th {
  border-left: 1px solid #eee !important;
}

.ant-table-bordered .ant-table-fixed-right table {
  border-left: 0 !important;
}
</style>
